module.exports = __webpack_public_path__ + "img/samsung-galaxy-note4.b25330bb.png";